/* eslint-disable max-len */
export const landing = {
  'answer-on-questions': 'Savollarga javob bering',
  'candidate-page-title': 'Nomzod anketasi',
  'choose-vacancy': 'Vakansiyani tanlang',
  'data-processing-and-agreement-links': 'Ehtimoliy ishga joylashish maqsadida <a href="/pd_processing_policy_uz.pdf" class="text-primary-100" target="_blank">shaxsiy maʼlumotlarim qayta ishlanishiga</a> rozilik beraman va <a href="/user_agreement_sm_podbor_uz.pdf" class="text-primary-100" target="_blank">Foydalanuvchi bilan kelishuvni</a> qabul qilaman',
  'do-you-lead-a-healthy-lifestyle': 'Sogʻlom turmush tarzini olib borasizmi?',
  'do-you-play-sport': 'Sport bilan shugʻullanasizmi?',
  'type-full-name': 'FIO kiriting',
  'type-first-name': 'Ismni kiriting',
  'type-last-name': 'Familiyangizni kiriting',
  'type-patronymic-name': 'Otasining ismini kiriting',
  'full-name': 'F.I.O.',
  'error:birthday': 'Tugʻilgan sanani tanlang',
  'error:citizenship': 'Fuqarolikni tanlang',
  'error:city': 'Shaharni tanlang',
  'error:email': 'Email manzilini kiriting',
  'error:correct-email': 'Email manzilini kiriting',
  'error:type-full-name': 'Familiya, ism va otasining ismini boʻsh joylar bilan ajratgan holda FIO kiriting',
  'error:type-first-name': 'Ismni kiriting',
  'error:type-last-name': 'Familiyangizni kiriting',
  'error:type-patronymic-name': 'Otasining ismini kiriting',
  'error:expected-income-level': 'Kutilayotgan daromad darajasini kiriting',
  'error:phone': 'Telefon raqamini kiriting',
  'error:phone-number': 'Telefon raqamini kiriting',
  'error:prefered-communication-method': 'Afzal aloqa usulini kiriting',
  'error:prefered-schedule': 'Grafikni tanlang',
  'error:store': 'Doʻkonni tanlang',
  'error:recommender-city': 'Shaharni kiriting',
  'expected-income-level': 'Kutilayotgan daromad darajasi, so’m',
  'fill-personal-data': 'Shaxsiy maʼlumotlarni toʻldiring',
  'fill-required-fields': 'Majburiy qatorlarni toʻldiring!',
  'for-example-basketball': 'Masalan, basketbol',
  'generating-telegram-link-please-wait': 'Telegram-bot havolasi shakllantirilmoqda. Sahifani tark etmang, bunga bir necha soniya vaqt ketishi mumkin.',
  'go-to-telegram': 'Telegramga oʻtish',
  'if-you-have-trouble-to-fill-form': 'Anketani toʻldirishda qiyinchiliklarga duch kelsangiz, 8 800 350 80 60 raqamiga telefon qiling',
  'if-you-have-trouble-to-fill-form-email': 'Sizda anketa to‘ldirishda muammolar bo‘lsa, <a href="mailto:Support_smpodbor@sportmaster.com">support_smpodbor@sportmaster.com</a> elektron pochtamizga murojaat qiling.',
  'full-name-exemplicant': 'Xusanov Xusan Xusanovich',
  'first-name-exemplicant': 'Xusan',
  'last-name-exemplicant': 'Xusanov',
  'patronymic-name-exemplicant': 'Xusanovich',
  'link-our-telegram-for-more-info': 'Suhbatning keyingi bosqichlariga oid maʼlumotlarni tezroq olish uchun <a :href="telegramLink" class="text-primary-100" target="_blank">Telegram</a> sahifamizga oʻting',
  'online-stage-personal-link-email': 'Pochtaga onlayn-bosqichdan oʻtish uchun shaxsiy havola yuboriladi.',
  'online-stage-video-recording-agreement': 'Onlayn bosqichdan oʻtish paytida video yozib olinishiga rozilik beraman.',
  'phone-number': 'Telefon raqami',
  'prefered-communication-method': 'Afzal aloqa usuli',
  'prefered-schedule': 'Istalgan grafik',
  'previous-step': 'Avvalgi qadam',
  'profile-vk': 'VK profili',
  'questionnaire-sent-successfully': 'Anketa muvaffaqiyatli yuborildi',
  'online-stage-personal-link-sent-on-your-email': '<strong>{userEmail}</strong> email manzilingizga onlayn-bosqichdan oʻtish uchun shaxsiy havola yuborildi',
  'sales-representative': 'Savdo vakili',
  'system-administrator': 'Tizim administratori',
  'type-birthday': 'Tugʻilgan sanani kiriting',
  'type-profile-vk-link': 'VK profili havolasini kiriting',
  'write-what-sport-do-you-do': 'Masalan, basketbol',
  'fill-questionnaire': 'Anketa maʼlumotlarini toʻldiring',
  birthday: 'Tugʻilgan sana',
  citizenship: 'Fuqarolik',
  city: 'Shahar',
  loader: 'Yuklovchi',
  next: 'Keyingisi',
  partner: 'Hamkor',
  phone: 'Telefon',
  email: 'E-mail',
  step: 'Qadam',
  store: 'Do‘kon',
  ITN: 'STIR',
  MSRN: 'KTUT',
  code: 'Код',
  'send-questionnaire': 'Anketani yuborish',
  'recommender-data-title': 'Tavsiya etuvchining maʼlumotlari',
  'has-work-in-this-company-before': 'Ilgari Sportmasterda ishlagan',
};
